import React from 'react'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Text from 'components_new/atoms/Text'

import SimpleDialog from 'components_new/molecules/SimpleDialog'

interface DeleteSourceDialogProps {
  /** Names of the ontology models that read from the source. */
  blockedBy: string[]
  onClose: () => void
  onDelete: () => void
  open: boolean
}

/**
 * A source that feeds an ontology model cannot be deleted — the dialog then
 * explains what is in the way instead of asking for a confirmation.
 */
const DeleteSourceDialog = (props: DeleteSourceDialogProps) => {
  const { blockedBy, onClose, onDelete, open } = props

  const blocked = blockedBy.length > 0

  return (
    <SimpleDialog
      actions={
        <>
          <Button onClick={onClose} variant="text">
            {blocked ? 'Stäng' : 'Avbryt'}
          </Button>
          {!blocked ? (
            <Button
              color="error"
              onClick={() => {
                onDelete()
                onClose()
              }}
              variant="contained"
            >
              Ta bort
            </Button>
          ) : null}
        </>
      }
      onClose={onClose}
      open={open}
      title={blocked ? 'Datakällan används' : 'Ta bort datakälla?'}
    >
      {blocked ? (
        <Box>
          <Text gutterBottom={true}>
            Datakällan används av modellerna nedan och kan inte tas bort. Ta
            bort beroendena först.
          </Text>
          {blockedBy.map((name) => (
            <Text component="div" key={name} variant="body2">
              {name}
            </Text>
          ))}
        </Box>
      ) : (
        <Text>
          Är du säker på att du vill ta bort datakällan? Detta kan resultera i
          att applikationer som är beroende av data slutar fungera.
        </Text>
      )}
    </SimpleDialog>
  )
}

export default DeleteSourceDialog
